import { jsx as _jsx } from "react/jsx-runtime";
import { EventDetailsPageUI } from './event-details-page-ui';
import { useRouter } from '../../context/router-context';
import { useViewer } from '../../context/viewer-context';
import { useEventDetailsQuery, UserRole, ContentType, } from '../../__generated__/graphql';
export function EventDetailsPage() {
    var _a, _b, _c, _d, _e;
    // Router
    var _f = useRouter(), match = _f.match, goBack = _f.goBack, goForwardClick = _f.goForwardClick;
    var eventId = match.params.eventId;
    // GraphQL query
    var _g = useEventDetailsQuery({
        variables: { eventId: eventId },
    }), loading = _g.loading, data = _g.data;
    // Viewer
    var _h = useViewer(), hasRole = _h.hasRole, viewer = _h.viewer;
    var isOwner = (viewer === null || viewer === void 0 ? void 0 : viewer.id) === ((_b = (_a = data === null || data === void 0 ? void 0 : data.event) === null || _a === void 0 ? void 0 : _a.createdBy) === null || _b === void 0 ? void 0 : _b.id);
    var canEdit = hasRole(UserRole.THOUGHT_LEADERSHIP__MODERATE) || isOwner;
    // Videos
    var videos = ((_c = data === null || data === void 0 ? void 0 : data.event) === null || _c === void 0 ? void 0 : _c.contents.filter(function (content) { return content.type === ContentType.VIDEO; }).filter(function (content) { return !!content.imageUrl; }).map(function (video) {
        return {
            id: video.id,
            name: video.title,
            description: video.description,
            imageUrl: video.imageUrl || '',
            onClick: goForwardClick('content/' + video.id),
        };
    })) || [];
    return (_jsx(EventDetailsPageUI, { loading: loading, name: ((_d = data === null || data === void 0 ? void 0 : data.event) === null || _d === void 0 ? void 0 : _d.name) || '', description: ((_e = data === null || data === void 0 ? void 0 : data.event) === null || _e === void 0 ? void 0 : _e.description) || '', onBackClick: goBack, onEditClick: canEdit ? goForwardClick('update') : undefined, videos: videos }, void 0));
}
//# sourceMappingURL=event-details-page.js.map